import * as AmazonCognitoIdentity from "amazon-cognito-identity-js";
import { CognitoUser } from "amazon-cognito-identity-js";
import { Auth } from "aws-amplify";
import { history } from "react-router-guard";
import { awsConfig } from "src/config";

export class AuthService {
  private createCognitoUser = (Username: string) => {
    const {
      aws_user_pools_id: UserPoolId,
      aws_user_pools_web_client_id: ClientId,
    } = awsConfig;

    const poolData = { UserPoolId, ClientId };
    const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
    const userData = {
      Username,
      Pool: userPool,
    };
    return new AmazonCognitoIdentity.CognitoUser(userData);
  }

  public sendVerificationCodeForPasswordReset = (Username: string): Promise<any> => {
    return new Promise((resolve, reject) => {
      const cognitoUser = this.createCognitoUser(Username);
      return cognitoUser.forgotPassword({
        onSuccess() {
          return resolve();
        },
        onFailure(err) {
          return reject(err);
        },
      })
    });
  }

  public changePassword = (Username: string, verificationCode: string, newPassword: string): Promise<any> => {
    return new Promise((resolve, reject) => {
      const cognitoUser = this.createCognitoUser(Username);
      return cognitoUser.confirmPassword(verificationCode, newPassword, {
        onSuccess() {
          return resolve();
        },
        onFailure(err) {
          return reject(err);
        },
      });
    });
  }

  public login = async (Username: string, Password: string): Promise<any> => {
    return new Promise((resolve, reject) => {
      const cognitoUser = this.createCognitoUser(Username);
      const authenticationData = {
        Username,
        Password,
      };
      const authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
        authenticationData
      );

      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: function(result: any) {
          const accessToken = result.getAccessToken().getJwtToken();
          const idToken = result.idToken.jwtToken;
          return resolve({ accessToken, idToken });
        },

        onFailure: function(err) {
          console.log(err)
          return reject(err);
        },
      });
    });
  };

  public isAuthenticated = async (): Promise<Boolean> => {
    try {
      const currentUser = await Auth.currentAuthenticatedUser({
        bypassCache: true,
      });
      await Auth.userAttributes(currentUser);
      await Auth.currentSession();
      return true;
    } catch {
      return false;
    }
  };

  public me = async (): Promise<CognitoUser> => {
    try {
      const currentUser = await Auth.currentAuthenticatedUser({
        bypassCache: true,
      });
      const attributes = await Auth.userAttributes(currentUser);
      currentUser.attributes = attributes;
      currentUser.data = {};
      for (const i of currentUser.attributes) {
        const attr = i;
        const { Name, Value } = attr;
        currentUser.data[Name] = Value;
      }
      return currentUser;
    } catch (error) {
      console.log(error);
      throw new Error("Unauthenticated");
    }
  };

  public logout = async (): Promise<void> => {
    await await Auth.signOut();
    localStorage.clear();
    history.push("/login");
  };
}
